/**
 * Client-side mirrors of the Malli schema in `src/metabase/agavepulse/branding.clj`.
 *
 * The server remains the authority and re-validates everything; these exist only so a
 * mistake shows up as inline text while typing rather than as a 400 on save. Keep the two
 * in sync -- a rule that is looser here just means a worse error message, but a rule that
 * is stricter here silently blocks something the server would have accepted.
 */

const HEX_COLOR = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

const MAX_LOGO_URL_LENGTH = 2048;

export function isValidHexColor(value: string): boolean {
  return HEX_COLOR.test(value);
}

export function isValidLogoUrl(value: string): boolean {
  return (
    value.length > 0 &&
    value.length <= MAX_LOGO_URL_LENGTH &&
    /^https:\/\//i.test(value)
  );
}
